import { useEffect, useMemo, useRef, useState } from "react";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { getAllRoadObjectsLayer, getGismeteoPrecipitationLayer } from "../../../widgets/map/mapFeatures/layers";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { animateLayerTransition } from "../../../widgets/map/mapFeatures/utils/animateLayerTransition";

export function MapGismeteoPrecipitation() {
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const cacheRef = useRef<{ [key: number]: any }>({});
    const activeLayerRef = useRef<any>(null);

    const time = useAppSelector(state => state.maps.gismeteoPrecipitation.time);
    const timeMarkIndex = useAppSelector(state => state.maps.gismeteoPrecipitation.timeMarkIndex);

    useEffect(() => {
        let newLayer;
        if (cacheRef.current[timeMarkIndex]) {
            newLayer = cacheRef.current[timeMarkIndex];
        } else {
            newLayer = getGismeteoPrecipitationLayer(timeMarkIndex, time);
            cacheRef.current[timeMarkIndex] = newLayer;
        }

        animateLayerTransition({
            previousLayer: activeLayerRef.current,
            newLayer,
            setLayers: setAdditionalLayers,
            duration: 300,
            opacity: 0.8
        });

        activeLayerRef.current = newLayer;
    }, [time, timeMarkIndex]);

    const roadsLayer = useMemo(() => getAllRoadObjectsLayer(), []);
    const permanentLayers: any = [roadsLayer];

    return (
        <>
            <ContentHeader title="Радар осадков и гроз" type="map" />
            <div className="map-gismeteo-precipitation-div">
                <div className="map-widget-with-toast near-overlay">
                    <ToastMessageContainer />
                    <MapWidget propsMaxZoom={9} additionalLayers={additionalLayers} permanentLayers={permanentLayers} />
                </div>
                <MapOverlayWidget />
            </div>
        </>
    );
}
